export default "__VITE_ASSET__BKpiNJoh__"